<div class="mobile-menu hide-on-med-and-up">
    <nav>
      <div class="nav-wrapper">
        <a href="#!" class="brand-logo">
            <img src="assets/images/mobile-menu-brand.svg" class="logo-image" />
        </a>
        <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>
        <ul class="right hide-on-med-and-down">
          <li><a href="sass.html">Sass</a></li>
          <li><a href="badges.html">Components</a></li>
          <li><a href="collapsible.html">Javascript</a></li>
          <li><a href="mobile.html">Mobile</a></li>
        </ul>
        <section class="cmd-h-100 cmd-pr-1">
            <div class="user-identity">
                <a class="btn-floating btn-small waves-effect waves-light icon-blue-light-4 cmd-mr-1"><i class="material-icons">perm_identity</i></a>
                <a class="btn-floating btn-small waves-effect waves-light icon-blue-light-4" (click)="logout()"><i class="material-icons">power_settings_new</i></a>
            </div>
        </section>
      </div>
    </nav>
  </div>
<ul class="sidenav" id="mobile-demo">
  <li *ngFor="let menuItem of menu?.childs; let first = first">{{ menuItem.label | translate}}
    <ul>
      <li *ngFor="let child of menuItem.childs"><a [routerLink]="[child.route]" routerLinkActive="active-link" (click)="expandReduceMenu()">{{ child.label | translate }}</a></li>
    </ul>
  </li>
</ul>
         